import { IShift } from './';
import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';
import { BaseEntity } from '../base/base.entity';
import { AuthUserService } from '../authsettings/services/authusers.service';
import { ISalaryScale } from './salaryScaleGroup.service';

export class IEmployee {
    id: string;
    nmbrsId: number;
    firstName: string;
    lastName: string;
    displayName: string;
    emailPrivate: string;
    lines: Array<any>;
    notes: string;
    shifts: IShift[];
    shiftCount: number;
    shiftHours: number;
    shiftDeclarationHours: number;
    doneShiftCount: number;
    approvedShiftCount: number;
    approvedShiftHours: number;
    declarationsApproved: boolean;
    userId: any;
    tags: string[];
    birthday? : string;
    userName: string; 
    inactive: boolean;
    shiftCanceledCount: number;
    shiftSickCount: number;
    shiftCanceledHours: number;
    shiftSickHours: number;
    telephoneMobilePrivate: string;
    employeeSalaryScales?: IEmployeeSalaryScale[];
    zzp?: boolean;
}

export interface IEmployeeSalaryScale extends BaseEntity {
    id: string;
    employeeId: string;
    salaryScaleId?: string; // Nullable gemaakt
    salaryScale?: ISalaryScale;
    order: number;
    scaleNumber?: number; // NIEUW: 1, 2, of 3
}

export interface IEmployeeSalaryScalesOverviewRow {
    employeeId: string;
    displayName: string;
    scale1CaoName?: string;
    scale1Trede?: string;
    scale1HourlyWage?: number;
    scale1ConversionFactor?: number;
    scale2CaoName?: string;
    scale2Trede?: string;
    scale2HourlyWage?: number;
    scale2ConversionFactor?: number;
    scale3CaoName?: string;
    scale3Trede?: string;
    scale3HourlyWage?: number;
    scale3ConversionFactor?: number;
}

export class IEmployeeSubscription extends BaseEntity {
    shiftId: string | number;
    employeeId?: string;
    comment: string;
}

export class EmployeesService extends BaseService<IEmployee> {
    constructor(
        Restangular: Restangular.IService,
        protected AppService: AppService,
        protected AuthUserService: AuthUserService) {
        "ngInject";
        super(Restangular, AppService, 'hr/employee');
    }

    public getEmployeesByStatus(active: boolean = true): ng.IPromise<IEmployee[]> {
        var type = '';
        if (active) {
            type = 'active';
        } else {
            type = 'inactive';
        }
        return this.Restangular.all(this.itemName).customGET('', { 'limit': 5000, 'type': type }).then((response: Restangular.ICollection) => {
            this.list = response.plain().value;
            return this.listLoaded(this.list);
        });
    }

    public getIsZZP(): ng.IPromise<any> {
        return  this.Restangular.all(this.itemName).one('iszzp').get().then((item) => {

            var e = item.result;

            return {"zzp" : e.zzp, "invoiceMonthly" : e.incoiceMonthly}

        });
    }

    public deleteAccount(authUser, employee): ng.IPromise<any> {
        // console.log('EmployeesService deleteAccount');
        return this.AuthUserService.delete(authUser.id).then(() => {
            employee.userId = "";
            return this.put(employee.id, employee).then((item) => {
                // console.log('Account removed');
                return item;
            });
        });
    }

    public createAccount(authUser, employee): ng.IPromise<any> {
        authUser.email = employee.emailPrivate;
        authUser.userName = employee.emailPrivate;
        employee.username = authUser.userName;
        authUser.roles = ['employee'];
        authUser.claims = {
            "displayName": employee.displayName,
            "employeeId": employee.id
        };
        return this.AuthUserService.post(authUser).then((response) => {
            employee.userId = response.id;
            return this.put(employee.id, employee).then((item) => {
                // console.log('Account created');
                return item;
            });
        });
    }

    public refresh = (id) => {
        return this.Restangular.one('hr/employee', id.toString()).one('refreshFromNmbrs', 'true').get().then((item) => {
            this.item = item;
            return item.plain();
        });
    }

    public refreshAll = () => {
        return this.Restangular.all('nmbrs/employeeupdate').getList().then((items: Restangular.ICollection) => {
            return items.plain();
        });
    }

    public getSalaryScalesOverview = (): ng.IPromise<IEmployeeSalaryScalesOverviewRow[]> => {
        return this.Restangular.all(this.itemName).customGET('salaryscales-overview').then((response: any) => {
            return response.plain ? response.plain() : response;
        });
    }

    public getSubscriptions = () => {
        return this.Restangular.all('hr/employee/subscriptions').getList().then((subscriptions: Restangular.ICollection) => {
            return subscriptions.plain();
        })
    }

    public getAvailability = () => {
        return this.Restangular.all('hr/employee/availability').getList().then((availability: Restangular.ICollection) => {
            return availability.plain();
        })
    }

    public getAvailabilityByRange = (start, end) => {
        return this.Restangular.all('hr/employee/availabilityByRange').getList({start: start, end: end }).then((availability: Restangular.ICollection) => {
            return availability.plain();
        })
    }

    public postSubscription = (data: IEmployeeSubscription) => {
        return this.Restangular.all('hr/employee/subscriptions').post(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item.plain();
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    }

    public putSubscription = (data: IEmployeeSubscription) => {
        return this.Restangular.one('hr/employee/subscriptions', data.id.toString()).customPUT(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item.plain();
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    }

    public gatBackoffice = () => {
        return this.Restangular.all('hr/employee/backoffice').getList().then((list: Restangular.ICollection) => {
            return list.plain();
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    }

    public getSalaryScales = (employeeId: string): ng.IPromise<IEmployeeSalaryScale[]> => {
        return this.Restangular.one(this.itemName, employeeId).one('salaryscales').get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        });
    }

    public addSalaryScale = (employeeId: string, salaryScaleId: string): ng.IPromise<IEmployeeSalaryScale> => {
        return this.Restangular.one(this.itemName, employeeId).customPOST({ salaryScaleId: salaryScaleId }, 'salaryscales').then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij toevoegen salary scale');
            throw error;
        });
    }

    public removeSalaryScale = (employeeId: string, salaryScaleId: string): ng.IPromise<void> => {
        return this.Restangular.one(this.itemName, employeeId).one('salaryscales', salaryScaleId).remove().then(() => {
            this.AppService.NotifyService.success('Verwijderd', 'Salary scale is verwijderd');
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij verwijderen salary scale');
            throw error;
        });
    }

    public addSalaryScaleToScaleNumber = (employeeId: string, salaryScaleId: string, scaleNumber: number): ng.IPromise<IEmployeeSalaryScale> => {
        return this.Restangular.one(this.itemName, employeeId).customPOST(
            { salaryScaleId: salaryScaleId, scaleNumber: scaleNumber }, 
            'salaryscales'
        ).then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij toevoegen salary scale');
            throw error;
        });
    }

    public removeSalaryScaleFromScaleNumber = (employeeId: string, scaleNumber: number): ng.IPromise<void> => {
        return this.Restangular.one(this.itemName, employeeId).one('salaryscales/scale', scaleNumber.toString()).remove().then(() => {
            this.AppService.NotifyService.success('Verwijderd', 'Salary scale is verwijderd');
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij verwijderen salary scale');
            throw error;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/employees.service.ts